import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AboutProperty from './response-pages/AboutProperty';
import ResponseTest from './response-pages/ResponseTest';
import PropertyFacilities from './response-pages/PropertyFacilities';
import RoomAmenities from './response-pages/RoomAmenities';
import SpecialEmergencies from './response-pages/SpecialEmergencies';
import PropertyContact from './response-pages/PropertyContact';
import PropertyActivities from './response-pages/PropertyActivities';
import PropertyLocation from './response-pages/PropertyLocation';
import PropertyFrontDesk from './response-pages/PropertyFrontDesk';
import AboutRooms from './about-rooms';
import RhAboutProperty from './response-pages/RhAboutProperty';
import RelatedTopics from './response-pages/RelatedTopics';
import AssistantOptions from './response-pages/AssistantOptions';
import HotelAssistantOptions from './response-pages/HotelAssistantOptions';
import SalonInformation from './response-pages/SalonInformation';
import SalonServices from './response-pages/SalonServices';
import Services from './services';
import EventCalendar from './EventCalendar';
import ServiceInsights from './services/components/ServiceInsights';
import ServiceOrder from './services/ServiceOrder';
import Locations from './locations';
import SalonAssistantOptions from './response-pages/SalonAssistantOptions';
import Gallery from './gallery';
import HolidayParkContact from './response-pages/HolidayParkContact';
import HolidayParkFacilities from './response-pages/HolidayParkFacilities';
import HolidayParkInformation from './response-pages/HolidayParkInformation';
import HolidayParkLocation from './response-pages/HolidayParkLocation';
import HolidayParkAssistantOptions from './response-pages/HolidayParkAssistantOptions';
import QBotAssistantOptions from './response-pages/QBotAssistantOptions';
import QBotInformation from './response-pages/QBotInformation';
import HolidayHomesAmenties from './response-pages/HolidayHomesAmenties';
import HolidayHomesAssistantOptions from './response-pages/HolidayHomesAssistantOptions';
import HolidayHomesInformation from './response-pages/HolidayHomesInformation';
import HolidayHomesPolicies from './response-pages/HolidayHomesPolicies';
import VVNAssistantOptions from './response-pages/VVNAssistantOptions';
import VVNInformation from './response-pages/VVNInformation';
import DCAssistantOptions from './response-pages/DCAssistantOptions';
import DCInformation from './response-pages/DCInformation';
import DCVoice from './response-pages/DCVoice';
import NorthableAbout from './response-pages/NorthableAbout';
import NorthableEquipment from './response-pages/NorthableEquipment';
import NorthableHelpline from './response-pages/NorthableHelpline';
import GolfProperty from './response-pages/GolfProperty';
import GolfServices from './response-pages/GolfServices';
import GolfGeneral from './response-pages/GolfGeneral';
import Recommender from './Recommender';
import products from './products';
import FavResponse from './response-pages/FavResponse';
import MissingResponse from './response-pages/MissingResponse';
import ActivitiesAssistantOptions from './response-pages/ActivitiesAssistantOptions';
import ActivitiesAssistantInformation from './response-pages/ActivitiesAssistantInformation';
import HotelGroupAssistantOptions from './response-pages/HotelGroupAssistantOptions';
import HolidayHomesGroupAssistantOptions from './response-pages/HolidayHomesGroupAssistantOptions';
import AboutGroupProperty from './about-properties';
import Outbound from './outbound';
import RestaurantAssistantInformation from './response-pages/RestaurantAssistantInformation';
import RestaurantAssistantOptions from './response-pages/RestaurantAssistantOption';
import HotelChannels from './response-pages/HotelChannels';
import HotelBio from './response-pages/HotelBio';
import CampingBio from './response-pages/CampingBio';
import ActivitiesBio from './response-pages/ActivitiesBio';
import Forms from './forms';
import Messenger from './messenger';
import IconGallery from './icon-gallery';
import Copilot from './copilot';
import PropertyMiscellaneous from './response-pages/PropertyMiscellaneous';
import UtilityPayment from './response-pages/UtilityPayment';
import UtilityBroadband from './response-pages/UtilityBroadband';
import UtilityEmergency from './response-pages/UtilityEmergency';
import UtilityMobile from './response-pages/UtilityMobile';
import UtilityMoving from './response-pages/UtilityMoving';
import PublishAI from './publish-ai';
import GuestsPass from './guestsPass';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/general-info`} />
      <Route path={`${match.url}/about-property`} component={AboutProperty} />
      <Route
        path={`${match.url}/property-facilities`}
        component={PropertyFacilities}
      />
      <Route path={`${match.url}/room-amenities`} component={RoomAmenities} />
      <Route
        path={`${match.url}/property-contact`}
        component={PropertyContact}
      />
      <Route
        path={`${match.url}/property-activities`}
        component={PropertyActivities}
      />
      <Route
        path={`${match.url}/property-location`}
        component={PropertyLocation}
      />
      <Route path={`${match.url}/copilot`} component={Copilot} />
      <Route
        path={`${match.url}/property-front-desk`}
        component={PropertyFrontDesk}
      />
      <Route path={`${match.url}/emergencies`} component={SpecialEmergencies} />
      <Route path={`${match.url}/response-test`} component={ResponseTest} />
      <Route path={`${match.url}/about-rooms`} component={AboutRooms} />
      <Route
        path={`${match.url}/about-rhproperty`}
        component={RhAboutProperty}
      />
      <Route path={`${match.url}/related-topics`} component={RelatedTopics} />
      <Route
        path={`${match.url}/assistant-options`}
        component={AssistantOptions}
      />
      <Route path={`${match.url}/guest-pass`} component={GuestsPass} />

      <Route
        path={`${match.url}/hotel-assistant-options`}
        component={HotelAssistantOptions}
      />
      <Route
        path={`${match.url}/salon-information`}
        component={SalonInformation}
      />
      <Route path={`${match.url}/salon-services`} component={SalonServices} />
      <Route path={`${match.url}/services`} component={Services} />
      <Route path={`${match.url}/EventCalendar`} component={EventCalendar} />
      <Route path={`${match.url}/service-order`} component={ServiceOrder} />
      <Route path={`${match.url}/messenger`} component={Messenger} />
      <Route
        path={`${match.url}/service-insights`}
        component={ServiceInsights}
      />
      <Route path={`${match.url}/locations`} component={Locations} />
      <Route
        path={`${match.url}/salon-assistant-options`}
        component={SalonAssistantOptions}
      />
      <Route path={`${match.url}/hp-contact`} component={HolidayParkContact} />
      <Route
        path={`${match.url}/hp-location`}
        component={HolidayParkLocation}
      />
      <Route
        path={`${match.url}/hp-facilities`}
        component={HolidayParkFacilities}
      />
      <Route
        path={`${match.url}/hp-information`}
        component={HolidayParkInformation}
      />
      <Route path={`${match.url}/gallery`} component={Gallery} />
      <Route
        path={`${match.url}/hp-assistant-options`}
        component={HolidayParkAssistantOptions}
      />
      <Route
        path={`${match.url}/qbot-assistant-options`}
        component={QBotAssistantOptions}
      />
      <Route
        path={`${match.url}/qbot-information`}
        component={QBotInformation}
      />
      <Route
        path={`${match.url}/hh-amenities`}
        component={HolidayHomesAmenties}
      />
      <Route
        path={`${match.url}/hh-assistant-options`}
        component={HolidayHomesAssistantOptions}
      />
      <Route
        path={`${match.url}/hh-information`}
        component={HolidayHomesInformation}
      />
      <Route
        path={`${match.url}/hh-policies`}
        component={HolidayHomesPolicies}
      />
      <Route
        path={`${match.url}/vvn-assistant-options`}
        component={VVNAssistantOptions}
      />
      <Route path={`${match.url}/vvn-information`} component={VVNInformation} />
      <Route path={`${match.url}/recommender`} component={Recommender} />
      <Route path={`${match.url}/products`} component={products} />
      <Route
        path={`${match.url}/dc-assistant-options`}
        component={DCAssistantOptions}
      />
      <Route
        path={`${match.url}/clinic-information`}
        component={DCInformation}
      />
      <Route path={`${match.url}/dc-voice`} component={DCVoice} />
      <Route path={`${match.url}/northable-about`} component={NorthableAbout} />
      <Route
        path={`${match.url}/northable-equipment`}
        component={NorthableEquipment}
      />
      <Route
        path={`${match.url}/northable-helpline`}
        component={NorthableHelpline}
      />
      <Route path={`${match.url}/golf-property`} component={GolfProperty} />
      <Route path={`${match.url}/golf-services`} component={GolfServices} />
      <Route path={`${match.url}/golf-general`} component={GolfGeneral} />
      <Route path={`${match.url}/favourite-response`} component={FavResponse} />
      <Route
        path={`${match.url}/missing-response`}
        component={MissingResponse}
      />
      <Route
        path={`${match.url}/activities-assistant-options`}
        component={ActivitiesAssistantOptions}
      />
      <Route
        path={`${match.url}/activities-assistant-information`}
        component={ActivitiesAssistantInformation}
      />
      <Route
        path={`${match.url}/restaurant-assistant-information`}
        component={RestaurantAssistantInformation}
      />
      <Route
        path={`${match.url}/restaurant-assistant-options`}
        component={RestaurantAssistantOptions}
      />
      <Route
        path={`${match.url}/about-group-property`}
        component={AboutGroupProperty}
      />
      <Route
        path={`${match.url}/hotel-group-assistant-options`}
        component={HotelGroupAssistantOptions}
      />
      <Route
        path={`${match.url}/hh-group-assistant-options`}
        component={HolidayHomesGroupAssistantOptions}
      />
      <Route path={`${match.url}/hotel-channels`} component={HotelChannels} />
      <Route path={`${match.url}/hotel-bio`} component={HotelBio} />
      <Route path={`${match.url}/camping-bio`} component={CampingBio} />
      <Route path={`${match.url}/activities-bio`} component={ActivitiesBio} />
      <Route
        path={`${match.url}/property-miscellaneous`}
        component={PropertyMiscellaneous}
      />
      <Route
        path={`${match.url}/utility-payments`}
        component={UtilityPayment}
      />
      <Route
        path={`${match.url}/utility-broadband`}
        component={UtilityBroadband}
      />
      <Route
        path={`${match.url}/utility-emergency`}
        component={UtilityEmergency}
      />
      <Route path={`${match.url}/utility-mobile`} component={UtilityMobile} />
      <Route path={`${match.url}/utility-moving`} component={UtilityMoving} />
      <Route path={`${match.url}/outbound`} component={Outbound} />
      <Route path={`${match.url}/forms`} component={Forms} />
      <Route path={`${match.url}/icon-gallery`} component={IconGallery} />
      <Route path={`${match.url}/publish-ai`} component={PublishAI} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
